"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "ghiffa": {
    "e93eb289": [{
      "hkey": "71d0fb25",
      "slug": "deccio-villaggio-valdora",
      "name": "Deccio-Villaggio Valdora",
      "primary": true,
      "skipSearch": false
    }],
    "deccio": [{
      "hkey": "71d0fb25",
      "slug": "deccio-villaggio-valdora",
      "name": "Deccio-Villaggio Valdora",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "6124c281": [{
      "hkey": "4c85140a",
      "slug": "ghiffa",
      "name": "Ghiffa",
      "primary": true,
      "skipSearch": false
    }],
    "arca": [{
      "hkey": "4c85140a",
      "slug": "ghiffa",
      "name": "Ghiffa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a4fc39d1": [{
      "hkey": "4c85140a",
      "slug": "ghiffa",
      "name": "Ghiffa",
      "primary": true,
      "skipSearch": false
    }],
    "bozzela": [{
      "hkey": "4c85140a",
      "slug": "ghiffa",
      "name": "Ghiffa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9b42413b": [{
      "hkey": "5c836f35",
      "slug": "cargiago-carpiano-ceredo",
      "name": "Cargiago-Carpiano-Ceredo",
      "primary": true,
      "skipSearch": false
    }],
    "cargiago": [{
      "hkey": "5c836f35",
      "slug": "cargiago-carpiano-ceredo",
      "name": "Cargiago-Carpiano-Ceredo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "85d47956": [{
      "hkey": "4c85140a",
      "slug": "ghiffa",
      "name": "Ghiffa",
      "primary": true,
      "skipSearch": false
    }],
    "caronio": [{
      "hkey": "4c85140a",
      "slug": "ghiffa",
      "name": "Ghiffa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "386da144": [{
      "hkey": "5c836f35",
      "slug": "cargiago-carpiano-ceredo",
      "name": "Cargiago-Carpiano-Ceredo",
      "primary": true,
      "skipSearch": false
    }],
    "carpiano": [{
      "hkey": "5c836f35",
      "slug": "cargiago-carpiano-ceredo",
      "name": "Cargiago-Carpiano-Ceredo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ghiffa"
    }],
    "17e61c4e": [{
      "hkey": "5c836f35",
      "slug": "cargiago-carpiano-ceredo",
      "name": "Cargiago-Carpiano-Ceredo",
      "primary": true,
      "skipSearch": false
    }],
    "ceredo": [{
      "hkey": "5c836f35",
      "slug": "cargiago-carpiano-ceredo",
      "name": "Cargiago-Carpiano-Ceredo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ghiffa"
    }],
    "863fceea": [{
      "hkey": "f07e0e44",
      "slug": "frino-san-maurizio-selva-susello",
      "name": "Frino-San Maurizio-Selva-Susello",
      "primary": true,
      "skipSearch": false
    }],
    "frino": [{
      "hkey": "f07e0e44",
      "slug": "frino-san-maurizio-selva-susello",
      "name": "Frino-San Maurizio-Selva-Susello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ghiffa"
    }],
    "16b0706a": [{
      "hkey": "f07e0e44",
      "slug": "frino-san-maurizio-selva-susello",
      "name": "Frino-San Maurizio-Selva-Susello",
      "primary": true,
      "skipSearch": false
    }],
    "rometto": [{
      "hkey": "f07e0e44",
      "slug": "frino-san-maurizio-selva-susello",
      "name": "Frino-San Maurizio-Selva-Susello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ghiffa"
    }],
    "c19a6ae3": [{
      "hkey": "872ed147",
      "slug": "ghiffa-ronco",
      "name": "Ghiffa-Ronco",
      "primary": true,
      "skipSearch": false
    }],
    "ronco": [{
      "hkey": "872ed147",
      "slug": "ghiffa-ronco",
      "name": "Ghiffa-Ronco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "f122dec4": [{
      "hkey": "f07e0e44",
      "slug": "frino-san-maurizio-selva-susello",
      "name": "Frino-San Maurizio-Selva-Susello",
      "primary": true,
      "skipSearch": false
    }],
    "san-maurizio": [{
      "hkey": "f07e0e44",
      "slug": "frino-san-maurizio-selva-susello",
      "name": "Frino-San Maurizio-Selva-Susello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ghiffa"
    }],
    "9d02212e": [{
      "hkey": "f07e0e44",
      "slug": "frino-san-maurizio-selva-susello",
      "name": "Frino-San Maurizio-Selva-Susello",
      "primary": true,
      "skipSearch": false
    }],
    "sasso": [{
      "hkey": "f07e0e44",
      "slug": "frino-san-maurizio-selva-susello",
      "name": "Frino-San Maurizio-Selva-Susello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ghiffa"
    }],
    "3226d739": [{
      "hkey": "f07e0e44",
      "slug": "frino-san-maurizio-selva-susello",
      "name": "Frino-San Maurizio-Selva-Susello",
      "primary": true,
      "skipSearch": false
    }],
    "selva": [{
      "hkey": "f07e0e44",
      "slug": "frino-san-maurizio-selva-susello",
      "name": "Frino-San Maurizio-Selva-Susello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ghiffa"
    }],
    "203f8070": [{
      "hkey": "f07e0e44",
      "slug": "frino-san-maurizio-selva-susello",
      "name": "Frino-San Maurizio-Selva-Susello",
      "primary": true,
      "skipSearch": false
    }],
    "susello": [{
      "hkey": "f07e0e44",
      "slug": "frino-san-maurizio-selva-susello",
      "name": "Frino-San Maurizio-Selva-Susello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "423edbc2": [{
      "hkey": "4c85140a",
      "slug": "ghiffa",
      "name": "Ghiffa",
      "primary": true,
      "skipSearch": false
    }],
    "villaggio-miralago": [{
      "hkey": "4c85140a",
      "slug": "ghiffa",
      "name": "Ghiffa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;